import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
})
export class DriverComponent implements OnInit {
  filteredDrivers: any
  driverModalObj: any;
  search: any;
  user: any;
  companyId: any;
  selectedStatus = '';
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  status: boolean = true;
  driverId: any;
  loading: any = null;
  private readonly searchSubject = new Subject<string | undefined>();
  constructor(private cedentialService: CredentialService,
    private sharedDataService: SharedDataService
  ) { }

  drivers: any = [];

  ngOnInit(): void {
    this.getUser();
    // this.listenSearch();
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(untilDestroyed(this))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.companyId = this.user.company.id
          this.getCompanyWiseDrives(this.currentPage);

        }
      });
  }


  getCompanyWiseDrives(page: any) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status
    };
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.cedentialService.getCompanyDrivers(this.companyId, queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.drivers = data.results
        this.driverId = data.results?.id
        this.filteredDrivers = [...this.drivers]
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  openDriverModal(driver: any) {
    this.driverModalObj = driver;

  }

onSaveDriver(evt: any) {
  if (evt) {
    // Create updated object with fullName
    const updatedDriver = {
      ...evt
    };

    // Find index in filteredDrivers
    const idx = this.filteredDrivers.findIndex((d:any) => d.id === evt.id);

    if (this.status === evt.isActive) {
      if (idx !== -1) this.filteredDrivers[idx] = updatedDriver;
    } else {
      if (idx !== -1) this.filteredDrivers.splice(idx, 1);
    }
  }

  // Close modal
  this.driverModalObj = null;
}


  onCloseDriverEditModal() {
    this.driverModalObj = null;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getCompanyWiseDrives(page);
  }

  onSelectStatus(): void {
    this.getCompanyWiseDrives(this.currentPage = 1);
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getCompanyWiseDrives(this.currentPage)
      });
  }

  onSyncDriver(driverId: string) {
    this.loading = driverId;
    this.cedentialService.syncData(driverId, 'drivers')
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          sweetAlert('Success', 'Driver Synced Successfully!', 'success', 'OK');
          this.getCompanyWiseDrives(this.currentPage);
        },
        error: (err) => {
          sweetAlert('Error', err?.error?.message, 'error', 'OK');
          this.loading = null;
        },
        complete: () => {
          this.loading = null;
        }
      });
  }
}
